import { APIS } from "../endpoints";
import api from "../services/api";

export const getAgraphySectionsData = async (alias) => {

    const result = await api.get(`${APIS.BASE_URL}admin/sections/${alias}`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

export const updateAgraphySectionsData = async (alias, data) => {

    const result = await api.put(`${APIS.BASE_URL}admin/sections/${alias}`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteAgraphySectionsData = async (alias, deletedItems) => {

    const result = await api.delete(`${APIS.BASE_URL}admin/sections/${alias}`, { data: { deletedItems } })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};
